import system from './api'
import wechat from './wechat'
import user from './user'
import answer from './answer'
import exchange from './exchange'
import address from './address'
import pay from './pay'
import mwap from './mwap'
import family from './wholefamily'
import sports from './sports'
import common from './common'
import health from './health'

export default {
    system,
    wechat,
    user,
    answer,
    exchange,
    pay,
    address,
    mwap,
    family,
    sports,
    common,
    health
}
